const faqSearch = document.getElementById('faq-search');
const searchResults = document.querySelector('.faq-search-results');
const themePage = document.getElementById('theme-page');
const themeGlobal = document.getElementById('theme-global');
const headerHeight = document.querySelector('header').offsetHeight + 20;

function faqinit(array_questions) {

    document.addEventListener('change', handleSearchInput, true);
    document.addEventListener('keyup', handleSearchInput, true);
    document.addEventListener('focus', handleSearchInput, true);

    function handleSearchInput(event) {
        if (event.target && event.target.id === 'faq-search') {
            //showTabFaq();

            const search = event.target.value;

            if (search && search.length > 3) {
                const searchResultsList = document.querySelectorAll('.faq-search-results li');

                document.querySelectorAll('#theme-global .theme').forEach(function(el) {
                    el.removeAttribute('is-displayed');
                });
                document.querySelectorAll('faq-element').forEach(function(el) {
                    el.removeAttribute('is-displayed');
                });
                document.querySelectorAll('faq-questions').forEach(function(el) {
                    slideUp(el);
                    el.removeAttribute('is-displayed');
                });

                searchResults.setAttribute('is-displayed', '');
                searchResultsList.forEach(function(li) {
                    li.setAttribute('is-displayed', '');
                    li.removeAttribute('hasMatch');
                });

                var array_match = [];

                array_questions.forEach(function(val) {
                    const nomUpper = val["nom"].toUpperCase();
                    const match = nomUpper.match(search.toUpperCase());

                    if (match) {
                        array_match.push(match);
                        const li = document.querySelector('li#brand_' + val['id']);
                        if (li) li.setAttribute('hasMatch', '');
                    }
                });

                document.querySelectorAll('.brand_item:not([hasMatch])').forEach(function(el) {
                    el.removeAttribute('is-displayed');
                });

                if (array_match.length === 0) {
                    searchResults.removeAttribute('is-displayed');
                }
            } else {
                searchResults.removeAttribute('is-displayed');
                document.querySelectorAll('.faq-search-results li').forEach(function(li) {
                    li.removeAttribute('is-displayed');
                    li.removeAttribute('hasMatch');
                });
            }
        }
    }

    let click_in_process = false;

    searchResults.addEventListener('mousedown', function() {
        click_in_process = true;
    });

    searchResults.addEventListener('mouseup', function() {
        click_in_process = false;
        faqSearch.focus();
    });

    faqSearch.addEventListener('blur', function() {
        if (!click_in_process) {
            searchResults.removeAttribute('is-displayed');
            document.querySelectorAll('.faq-search-results li').forEach(function(li) {
                li.setAttribute('is-displayed', '');
                li.removeAttribute('hasMatch');
            });
        }
    });

    document.querySelectorAll('#theme-global .theme').forEach(function(el) {
        el.addEventListener('click', function() {
            const id = el.getAttribute('data-id');

            document.querySelectorAll('#theme-global .theme').forEach(function(theme) {
                theme.removeAttribute('is-displayed');
            });

            el.setAttribute('is-displayed', '');
            showTabFaq(id, 1);

            const themePageRect = themePage.getBoundingClientRect();
            const scrollTop = window.pageYOffset + themePageRect.top - headerHeight;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        });
    });

    document.querySelectorAll('#theme-page .theme').forEach(function(el) {
        el.addEventListener('click', function() {
            const id = el.getAttribute('data-id');
            showTabFaq(id, 1);
        });
    });
}

function researchFaq(node_id, level, question_id) {

    setTimeout(function() {
        const displayedQuestion = document.querySelector('.faq-question[is-displayed]');
        if (displayedQuestion) {
            const top = displayedQuestion.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }, 400);

    searchResults.removeAttribute('is-displayed');

    document.querySelectorAll('.faq-search-results li').forEach(function(li) {
        li.setAttribute('is-displayed', '');
        li.removeAttribute('hasMatch');
    });

    if (document.getElementById('theme-global').hasAttribute("is-displayed")) {
        document.getElementById('theme-page').setAttribute('is-displayed', '');
    }

    const themeNode = document.querySelector(".faq-theme-" + node_id);
    if (themeNode && !themeNode.hasAttribute("is-displayed")) {
        showTabFaq(node_id, level);
    }

    showTabFaq(node_id, level, question_id);

    const questionElem = document.querySelector('.faq-question-' + question_id);

    questionElem.setAttribute('is-displayed', '');
    if (questionElem) {
        const top = questionElem.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
    }
}

function showTabFaq(node_id, level, question_id) {
    if (question_id !== null && question_id !== undefined) {
        if (document.querySelector('.faq-reponse-' + question_id).hasAttribute('is-displayed')) {
            slideUp(document.querySelector('.faq-reponse-' + question_id));
            document.querySelector('.faq-reponse-' + question_id).removeAttribute('is-displayed');
        } else {
            document.querySelectorAll('.faq-reponse').forEach(function(el) {
                if (!el.classList.contains('faq-reponse-' + question_id)) {
                    slideUp(el);
                    el.removeAttribute('is-displayed');
                }
            });

            setTimeout(function() {
                slideDown(document.querySelector('.faq-reponse-' + question_id));
                document.querySelector('.faq-reponse-' + question_id).setAttribute('is-displayed', '');
            }, 0);

            document.querySelectorAll('.faq-question').forEach(function(el) {
                el.removeAttribute('is-displayed');
            });

            setTimeout(function() {
                document.querySelector('.faq-question-' + question_id).setAttribute('is-displayed', '');
            }, 0);
        }
    } else {
        const parent_id = document.querySelector(".faq-theme-" + node_id)?.getAttribute("data-parent");

        document.querySelectorAll('.faq-element:not(.faq-theme-' + node_id + ')').forEach(function(el) {
            el.removeAttribute('is-displayed');
        });

        document.querySelector('.faq-theme-' + node_id).setAttribute('is-displayed', '');
        if (parent_id) {
            document.querySelector('.faq-theme-' + parent_id).setAttribute('is-displayed', '');
        }

        document.querySelectorAll('.faq-questions').forEach(function(el) {
            slideUp(el);
            el.removeAttribute('is-displayed');
        });

        setTimeout(function() {
            slideDown(document.querySelector('.faq-questions-' + node_id));
            document.querySelector('.faq-questions-' + node_id).setAttribute('is-displayed', '');
        }, 0);

        document.querySelectorAll('.faq-level-' + level + ':not(.faq-theme-' + node_id + ')').forEach(function(el) {
            var id = el.getAttribute('data-id');
            var parents = document.querySelectorAll('.faq-level-parent-' + id);
            parents.forEach(function(parent) {
                slideUp(parent);
                parent.removeAttribute('is-displayed');
                // Custom event for "classChange"
                var event = new Event('classChange');
                parent.dispatchEvent(event);
            });
        });

        document.querySelectorAll('.faq-level-parent-' + node_id).forEach(function(el) {
            // Slide toggle logic (simulate jQuery's slideToggle)
            if (el.hasAttribute('is-displayed')) {
                slideUp(el);
                el.removeAttribute('is-displayed');
            } else {
                slideDown(el);
                el.setAttribute('is-displayed', '');
            }

            // Dispatch custom "classChange" event
            var event = new Event('classChange');
            el.dispatchEvent(event);
        });

        document.querySelectorAll('.faq-element').forEach(function(el) {
            el.addEventListener('classChange', function() {
                var id = el.getAttribute('data-id');
                if (!el.hasAttribute('is-displayed')) {
                    document.querySelectorAll('.faq-level-parent-' + id).forEach(function(parent) {
                        parent.removeAttribute('is-displayed');
                        var event = new Event('classChange');
                        parent.dispatchEvent(event);
                    });
                }
            });
        });
    }
}